module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA0UlEQVR4AWOgC/h/5EhU9d4jF57/Dw8Hko5pm4EiDMYzsSAIAKoGqoBrALKBevBp+P///9+/f4EkUMN/GMCnAagOiuTk4Gyg9It9oT9XmX/bI3y5j+/u1gCEBoijEU5asaK3fy9Q+smugN/TIn6uETleznhjgzeSDdOn+xXugGuo7toP8fTOBY4/97CuShR7voRpx1xHhAYgCyvyD4m4dIqLZbbK2TM8AaERhDUwG/Q0TLL33SVdM8kByMarAaGnyy++lMWgC8JFaCCIyNUwKAEAnmXDTpgmWN0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/TC.png
// module id = 1274
// module chunks = 0